<script setup>
import { computed, onBeforeUnmount, ref, toRaw, watch } from 'vue'
import printJS from 'print-js'

defineEmits(['loaded'])
const props = defineProps(['link', 'scale', 'mime'])
const scaleCSS = computed(() => `scale(${props.scale ?? 1})`)

/** blob: URL — без btoa/spread на больших JPG (RangeError: Maximum call stack size exceeded). */
const blobUrl = ref(null)

/**
 * Собирает data:/blob: URL из bytes или готовой строки.
 *
 * @param {Uint8Array|ArrayBuffer|string|null|undefined} link
 * @param {string|null|undefined} mime
 * @returns {string|null}
 */
function buildImageSrc(link, mime) {
  if (!link) {
    return null
  }
  if (typeof link === 'string') {
    return link
  }
  const raw = toRaw(link)
  const bytes =
    raw instanceof ArrayBuffer
      ? new Uint8Array(raw)
      : raw instanceof Uint8Array
        ? raw
        : ArrayBuffer.isView(raw)
          ? new Uint8Array(raw.buffer)
          : null
  if (!bytes?.length) {
    return null
  }
  const type = mime && String(mime).startsWith('image/') ? mime : 'image/jpeg'
  return URL.createObjectURL(new Blob([bytes], { type }))
}

watch(
  () => [props.link, props.mime],
  () => {
    if (blobUrl.value?.startsWith('blob:')) {
      URL.revokeObjectURL(blobUrl.value)
    }
    blobUrl.value = buildImageSrc(props.link, props.mime)
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  if (blobUrl.value?.startsWith('blob:')) {
    URL.revokeObjectURL(blobUrl.value)
  }
})

const src = computed(() => blobUrl.value)

defineExpose({
  print: () => {
    if (!src.value) {
      return
    }
    printJS(src.value, 'image')
  },
})
</script>

<template>
  <div class="vstack gap-3 pt-3" ref="pages-canva">
    <div class="pdf-view border align-self-center shadow" ref="page-el">
      <img v-if="src" :src="src" @load="$emit('loaded')" />
    </div>
  </div>
</template>

<style scoped>
.vstack {
  min-height: 100%;
  min-width: 100%;
  width: fit-content;
}
.pdf-view {
  transform: v-bind('scaleCSS');
  transform-origin: left top;
}
</style>
